import { gql } from "@apollo/client";

const schema = {
  get: {
    name: "city",
    serviceName: "graphql",
    query: gql`
      query city($ids: [String]) {
        city(ids: $ids) {
          data {
            title
            details
            state {
              id
              title
            }
          }
          total
        }
      }
    `,
  },
  update: {
    name: "updateCity",
    serviceName: "admin",
    query: gql`
      mutation updateCity(
        $ids: [String]!
        $state_id: String
        $title: String
        $details: String
      ) {
        updateCity(
          ids: $ids
          title: $title
          state_id: $state_id
          details: $details
        ) {
          influenced_count
          messages
        }
      }
    `,
  },
};

export default schema;
